import {
    isElement,
    uniqueId,
    merge
} from "lodash";

import {
    POPOVER_
} from "../../02-const/id-names";

/* ================================== Const ================================= */

const
    moduleName = 'popover',
    baseClassName = `js-${moduleName}`,
    baseSelector = `.${baseClassName}`,

    cssClass = {
        isHidden: 'is-hidden',
        hasCloseButton: 'has-close-button'
    },

    popoverDefaultConfig = {
        selectors: {
            closeButton: `${baseSelector}__close`
        }
    };

/* ============================ Class defenition ============================ */

export default class Popover {
    constructor(baseElement, config = {}) {
        if (!isElement(baseElement)) {
            throw "Unable to create instance of Popover, no baseElement has been provided";
        }

        const mergedConfig = merge({}, popoverDefaultConfig, config);
        this._configure(baseElement, mergedConfig);
        this._setup();
    }

    /* ======================== Private init methods ======================== */

    _configure(baseElement, config) {
        this.baseElement = baseElement;
        this.config = config;
        this.id = uniqueId(POPOVER_);
        this.closeButtonElement = baseElement.querySelector(config.selectors.closeButton);
    }

    _setup() {
        this._addStyling();
        this._bindCloseEventListener();
        this.show();
    }

    _throwError(elementName) {
        throw `Unable to find ${elementName} in Popover (${this.id}), no element has been provided`;
    }

    /* =========================== Public Methods =========================== */
    show() {
        this.baseElement.classList.remove(cssClass.isHidden);
    }

    hide() {
        this.baseElement.classList.add(cssClass.isHidden);
    }

    destroy() {
        if(this.boundEvent) {
            this.closeButtonElement.removeEventListener('click', this.boundEvent);
        }
    }

    /* =========================== Private Methods ========================== */

    _addStyling() {
        if (!isElement(this.closeButtonElement)) {
            this.baseElement.classList.remove(cssClass.hasCloseButton);
        }
    }

    _bindCloseEventListener() {
        // Since event listeners change the scope of 'this', we need to make
        // sure we are able to remove this event, so we define it before adding.
        if(isElement(this.closeButtonElement)) {
            this.boundEvent = event => this._onCloseClicked(event);
            this.closeButtonElement.addEventListener('click', this.boundEvent);
        }
    }

    _onCloseClicked(event) {
        this.hide();
    }
}
